import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { FloatingActionButton } from '@pets-ui/FloatingActionButton/FloatingActionButton'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import * as stylex from '@stylexjs/stylex'
import { useHistory } from 'react-router-dom-v5'
import AiIcon from '../../../fp-b2b-shared/ai-purchase-order/assets/icons/ai-icon.svg?react'
import { getButlerEntryPath } from '../../../fp-b2b-shared/ai-purchase-order/constants'

const styles = stylex.create({
  floatingButton: {
    backgroundImage: 'linear-gradient(136deg, #AFD8FF 16.72%, #06F 53.7%, #CA73FF 84.32%)',
  },
})

export interface QuickOrderFabProps {
  basePath: string
}

/** 放在 PageFooter 的 transparent footer 層，位置由 FooterStack 決定，會浮在 sticky bar 上方 */
export const QuickOrderFab = ({ basePath }: QuickOrderFabProps) => {
  const history = useHistory()
  const entryPath = getButlerEntryPath(basePath, Platform.STM)

  return (
    <Tooltip title={<Text variant="caption">快速下單，幫你快速完成採購工作</Text>} placement="left" offset={[0, 16]} strategy="fixed">
      <FloatingActionButton size="large" rootStyle={styles.floatingButton} onClick={() => history.push(entryPath)}>
        <SvgIcon fontSize={24} color={colors.white}>
          <AiIcon />
        </SvgIcon>
      </FloatingActionButton>
    </Tooltip>
  )
}
